import { reduxTypes as types } from 'Utils';

export default types({
  prefix: 'Catalog',
  constants: [
    'GET_FILTERED_COURSES',
    'SET_SCP',
    'SELECT_FILTER',
    'UNSELECT_FILTER',

    'SET_FILTERS',
    'OPEN_FILTER_CATEGORY',
    'TOGGLE_FILTER_CATEGORY',

    'OPEN_FILTER_SOFTWARE',
    'TOGGLE_FILTER_SOFTWARE',

    'TOGGLE_FILTER_LEVEL',
    'OPEN_FILTER_LEVEL',

    'TOGGLE_FILTER_LANGUAGE',
    'OPEN_FILTER_LANGUAGE',
    'SET_SELECTED_LANGUAGES',

    'CLEAR_ALL_FILTERS',
    'CLEAR_SOFTWARE_FILTERS',
    'CLEAR_LEVELS_FILTERS',
    'TOGGLE_FILTER_DIALOG',

    'SET_ORDERBY',
    'SELECT_ORDERBY',
    'SET_DEFAULT_ORDERBY',

    'SHOW_ALL_COURSES',
    'CLEAR_SEARCH',

    'DISABLE_FILTERS_SOFTWARE_LEVELS',

    'UPDATE_PROP',
    'TOGGLE_ITEM_SELECTION',
    'TOGGLE_SUBCATEGORY',
    'TOGGLE_SECTION',
    'TOGGLE_FILTER',
    'CLEAR_CATEGORY',
    'CLEAR_ALL',
    'TOGGLE_DIALOG',
  ],
});
